/**
 * Página de redirecionamento do Pacote Cenoura.
 * Acessível diretamente via #/redirect?url=...&countdown=10 (sem passar pela splash, sem Artemis/auth).
 * Query params: url (obrigatório), countdown (segundos, opcional, default 10).
 * Centraliza a lógica de countdown e conectividade reutilizando CarrotRedirectDialogComponent;
 * ao final o callback redireciona esta aba (window.location.href).
 */

import { CarrotRedirectDialogComponent } from '../components/carrot-redirect-dialog.component';
import { logger } from '../utils/logger.util';

const DEFAULT_COUNTDOWN = 10;

export class CarrotRedirectPage {
  private container: HTMLElement;

  constructor(container: HTMLElement) {
    this.container = container;
  }

  /**
   * Lê query params do hash (router grava em sessionStorage como query_param_*).
   */
  private getQueryParam(name: string): string | null {
    const fromStorage = sessionStorage.getItem(`query_param_${name}`);
    if (fromStorage) return fromStorage;
    const hash = window.location.hash.slice(1);
    const queryIndex = hash.indexOf('?');
    if (queryIndex >= 0) {
      const params = new URLSearchParams(hash.substring(queryIndex + 1));
      return params.get(name);
    }
    return null;
  }

  /**
   * Lê o countdown em segundos dos query params (?countdown=10).
   * Retorna null se ausente ou inválido; o caller pode usar DEFAULT_COUNTDOWN.
   */
  private getCountdownFromParams(): number | null {
    const raw = this.getQueryParam('countdown');
    if (raw == null) return null;
    const n = parseInt(raw, 10);
    if (Number.isNaN(n) || n < 0) return null;
    return n;
  }

  async render(): Promise<void> {
    const targetUrl = this.getQueryParam('url');
    if (!targetUrl) {
      logger.warnWithContext('CarrotRedirectPage', 'URL de destino ausente (use ?url=...)');
      this.renderError('Link não encontrado.');
      return;
    }

    const countdown = this.getCountdownFromParams() ?? DEFAULT_COUNTDOWN;

    if (countdown <= 0) {
      window.location.href = targetUrl;
      return;
    }

    // Fundo full-page; o dialog é exibido por cima (centraliza countdown + conectividade).
    this.container.innerHTML = `
      <div class="carrot-redirect-page" style="min-height: 100vh; background: #f5f5f5;"></div>
    `;

    CarrotRedirectDialogComponent.show(countdown, () => {
      window.location.href = targetUrl;
    });
  }

  private renderError(message: string): void {
    this.container.innerHTML = `
      <div style="min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 24px; background: #f5f5f5;">
        <div style="background: white; border-radius: 16px; padding: 40px 32px; text-align: center;">
          <p style="font-size: 16px; color: rgba(0,0,0,0.87); margin: 0 0 16px;">${message}</p>
          <a href="#" style="color: #660099; font-size: 14px;">Voltar</a>
        </div>
      </div>
    `;
  }
}
